<template>
   <section class="news-blocks">
      <div
         class="block"
         v-for="(block, index) in field.newsBlocks"
         :key="index"
      >
         <ClientOnly>
            <NuxtLink :to="urlCleaner(block.url)">
               <!-- target="_blank" rel="noopener noreferrer" -->
               <!-- has to be the same format as what is saved via the nova JsonRepeater plugin -->
               <Image
                  :image="block.image && JSON.parse(block?.image).images[0]"
                  v-if="block.image && JSON.parse(block?.image).images[0]"
                  fit="cover"
               />

               <div class="text">
                  <h5 class="small">{{ block.headline }}</h5>
                  <p class="small">{{ block.content }}</p>
               </div>
            </NuxtLink>
         </ClientOnly>
      </div>
   </section>
</template>

<script setup lang="ts">
import { useAuthStore } from "../../stores/useAuthStore";

const props = defineProps({
   layout: { type: String, required: true },
   attributes: { type: Object, required: true },
});

const field = toRef(props, "attributes");
const urlCleaner = (url) => {
   return url.startsWith("http") && url.includes(location?.host)
      ? url.replace(/^https?:\/\/[^/]+/, "")
      : url;
};
</script>

<style lang="scss" scoped>
section.news-blocks {
   width: 100vw;
   position: relative;
   display: flex;
   flex-wrap: nowrap;

   div.block {
      flex: 1;
      overflow: hidden;
      position: relative;
      height: 400px;

      a {
         position: absolute;
         inset: 0;
         display: grid;
         align-items: end;
         color: white;
      }
      figure {
         position: absolute;
         inset: 0;
         z-index: 0;
         &:after {
            content: "";
            position: absolute;
            inset: 0;
            background: linear-gradient(transparent, $black);
            mix-blend-mode: multiply;
         }
      }
      div.text {
         justify-items: flex-start;
         align-items: flex-end;
         position: relative;
         z-index: 1;
         padding: pad(4);
         h5 {
            margin-bottom: pad(1);
         }
      }
   }
}
</style>
